<template>
  <div class="chat_box">
    <div class="prof seller">
      <div class="inner">
        <img
          src="@/assets/front/images/v2/profiles/img_perce_prof_w.png"
          alt=""
        />
      </div>
    </div>
    <div class="chat_con perce_chat_con" v-if="isCustomer">
      <div class="chat_txt">
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          KT 총액 결합할인 상품이란?
          <div class="notice_sub_txt">
            인터넷과 휴대폰(최대7개)을 결합하여 가족간 휴대폰 요금 총액에 따라
            아래와 같이 할인
          </div>
        </div>
        <div class="chat_msg system">
          <div class="notice_info_1 mb">
            <div class="txt_1">총액 결합할인</div>
            <div class="txt_2">유선할인</div>
          </div>
          <div class="notice_info_2 mb">
            <div class="txt_1">22,000원<br />미만</div>
            <div class="txt_2">
              <div>100M 이하 1,650원 할인</div>
              <div>500M 이상 2,200원 할인</div>
            </div>
          </div>
          <div class="notice_info_2 mb">
            <div class="txt_1">22,000원<br />이상</div>
            <div class="txt_2">
              <div>100M 이하 3,300원 할인</div>
              <div>500M 이상 5,500원 할인</div>
            </div>
          </div>
          <div class="notice_info_2">
            <div class="txt_1">64,900원<br />이상</div>
            <div class="txt_2">
              <div>100M 이하 5,500원 할인</div>
              <div>500M 이상 5,500원 할인</div>
            </div>
          </div>
        </div>
      </div>
      <button class="chat_txt_btn" @click="openImageViewModal('tvChannel')">
        <i class="i_chat_tv_channel"></i>KT TV채널 확인하기
      </button>
      <button
        v-if="getViewDate()"
        class="chat_txt_btn"
        @click="openImageViewModal('internetInstallCost')"
      >
        <i class="i_chat_install_cost"></i>설치비 안내 보기
      </button>
    </div>
    <div class="chat_con perce_chat_con" v-else>
      <div class="chat_txt">
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          고객님과 계약시 반드시<br />
          가입신청서를 이용해주세요!
        </div>
        <div class="chat_msg system">
          가입신청서는 열람권을 통해서만 열람이 가능하며, 부족한 열람권은
          제로노트에서 구매 가능합니다. (가입신청서가 아닌 직거래 유도 시 제재의
          대상이 됩니다)
        </div>
      </div>
      <button class="chat_txt_btn" @click="sendText(text1)">
        <i class="i_chat_chat"></i>{{ text1 }}
      </button>
      <button class="chat_txt_btn" @click="sendText(text2)">
        <i class="i_chat_chat"></i>{{ text2 }}
      </button>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format';
export default {
  name: 'ChatRoomInternetKt2408Notice',
  description: '인터넷 신청서 시스템 알림',
  props: {
    isCustomer: Boolean,
  },
  data() {
    return {
      text1: '안녕하세요! 반갑습니다!',
      text2: '가입을 위해 가입신청서를 보내주세요!',
    };
  },
  methods: {
    openInternetQuotationList() {
      this.$emit('openInternetQuotationList');
    },
    reportStore() {
      this.$emit('report');
    },
    sendText(val) {
      this.$emit('send', val);
    },
    openImageViewModal(type) {
      this.$emit('openImageViewModal', type);
    },
    getViewDate() {
      const limitDate = format(new Date('2025-03-05'), 'yyyy-MM-dd');
      const today = format(new Date(), 'yyyy-MM-dd');

      if (limitDate <= today) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style></style>
